// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3SIbT","placeholdersHeader":"styles_placeholdersHeader__Stf7n","editorStyle":"styles_editorStyle__vlnoN","placeholdersBox":"styles_placeholdersBox__3MLBJ"};